/** YouTube video ids are 11 characters from the URL-safe base64 alphabet. */
const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;

/**
 * Stand videos store a bare YouTube id. Anything else — a full URL, stray
 * whitespace, an id from another provider — is rejected rather than built into
 * an embed or image URL that would only fail.
 */
export function parseYouTubeId(value: string): string | undefined {
  const id = value.trim();

  return VIDEO_ID.test(id) ? id : undefined;
}

/** `hqdefault` exists for every video; the larger sizes do not. */
export function youTubeThumbnailUrl(id: string): string {
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}

/**
 * The privacy-enhanced host: YouTube sets no cookies until the visitor plays
 * the video, which keeps the page within what the cookie banner allows before
 * consent. Autoplay is safe because the player is only created by a tap.
 */
export function youTubeEmbedUrl(id: string): string {
  return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
}
